import {Stack, SxProps, Typography} from "@mui/material";
import CalendarIcon from "assets/icons/Calendar";

interface DateTextProps {
  date: string;
  sx?: SxProps;
}

const DateText = ({date, sx}: DateTextProps) => {
  const formattedDate = new Date(date).toLocaleDateString('ru-RU', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
  return (
    <Stack direction={'row'} alignItems={'center'} spacing={1} sx={{...sx, color: 'black.100', opacity: 0.5}}>
      <CalendarIcon sx={{width: 16, height: 16}}/>
      <Typography variant={'p3'}>
        {formattedDate}
      </Typography>
    </Stack>
  )
}

export default DateText;
